import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useEffect } from 'react';

import type { Role } from '@/components/RolePermissions/RolePermissions.types';
import useHandleError from '@/hooks/useHandleError';

const useFetchRolePermissions = () => {
  const handleError = useHandleError();
  const { refetch, data, error, isError, isFetching, isPending } = useQuery<
    Role[],
    AxiosError
  >({
    queryKey: ['roles/permissions'],
    staleTime: 60 * 10 * 1000 // 10 minutes
  });

  useEffect(() => {
    if (isError) {
      handleError(error, 'Failure to load roles and permissions.');
    }
  }, [isError, handleError, error]);

  return {
    refetch,
    isFetching,
    isPending,
    data
  };
};

export default useFetchRolePermissions;
